module.exports = __webpack_public_path__ + "static/media/jonas-lee-o6elTKWZ5bI-unsplash.08caa71d.jpg";